@use '@css/variables';



.shortcuts
{
  background: white;



  & > div {
    padding: 1em 1.5em !important;
  }

  ul {

    display: flex;
    flex-direction: row;
    list-style: none;
    gap: 0.5em 1em;
    flex-wrap: wrap;
    margin: 0;

    li {

      border-radius: var(--border-radius);
      background: var(--beigelight);
      white-space: nowrap;

      &:hover {
        background-color: var(--beigedark);
      }

      a {
        font-size: small;
        margin: 10px;
        color: black;
        display: inline-block;
      }
    }
  }
}

@media only screen and (min-width: variables.$md-breakpoint) {

  .shortcuts {

    .wrapper {

      max-width: calc(1200px + 3em);
    }
    &.extended {

      .wrapper {

        max-width: calc(1200px);
        padding-left: 230px !important;
      }
    }

  }
}
